import { Types } from './actionTypes';

const initialState = {
  profile: {
    userName: '',
    name: '',
    emailId: '',
    salesPersonId: 0
  },
  trip: {
    id: 0,
    name: '',
  },
  isUserLoggedIn: false,
  isTripLogin: false,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.LOGIN:
      console.log("Logging in");
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      return {
            ...state,
            profile: action.payload.user,
            isUserLoggedIn: true,
            isTripLogin: false
      }      
    case Types.TRIP_LOGIN:
      console.log("Trip login called");
      localStorage.clear();
      return {
            ...state,
            trip: action.payload.trip,
            isUserLoggedIn: true,
            isTripLogin: true
        }
    case Types.LOGOUT:
      console.log("Logging out");
      localStorage.clear();
      return {
            ...state,
            profile: initialState,
            isUserLoggedIn: false,
            isTripLogin: false
        }
    default:
      return state;
  }
}

export default reducer;